(() => {
  if (window.mcHomeShoppingReady) return;
  window.mcHomeShoppingReady = true;
  function init(root = document) {
    root.querySelectorAll('.mc-authentic-reviews img[data-src]').forEach(img => {
      if (!img.getAttribute('src')) {
        img.src = img.dataset.src;
        img.loading = 'lazy';
        img.width = 70; img.height = 70;
      }
    });
    root.querySelectorAll('[data-new-arrivals]').forEach(async section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      try {
        // Shopify sorts the whole catalog before paginating, including future products.
        const response = await fetch(section.dataset.url);
        if (!response.ok) throw new Error('New arrivals unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const cards = [...html.querySelectorAll('[data-arrivals-grid] > article')];
        if (cards.length) section.querySelector('[data-arrivals-grid]').replaceChildren(...cards.slice(0, Number(section.dataset.limit)));
      } catch (_) { /* Keep the server-rendered product cards and collection link. */ }
    });
    root.querySelectorAll('[data-routine]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const panels = [...section.querySelectorAll('[data-routine-panel]')];
      let panelIndex = 0;
      if (panels.length) panels[0].hidden = false;
      const steps = [...section.querySelectorAll('[data-routine-step]')];
      section.style.setProperty('--routine-columns', Math.max(steps.length, 1));
      const add = section.querySelector('[data-add-routine]');
      const shuffle = section.querySelector('[data-shuffle]');
      const status = section.querySelector('[data-routine-status]');
      let busy = false;
      const activeChoices = () => steps.filter(step => !step.closest('[data-routine-panel]').hidden).map(step => step.querySelector('[data-routine-choice]:not([hidden])'));
      function update() {
        const active = activeChoices();
        section.style.setProperty('--routine-columns', Math.max(active.length, 1));
        add.disabled = busy || !active.length || active.some(choice => !choice);
        const total = active.reduce((sum, choice) => sum + Number(choice?.querySelector('select')?.selectedOptions[0]?.dataset.price || 0), 0);
        const currency = window.Shopify?.currency?.active || 'INR';
        section.querySelector('[data-routine-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency',currency}).format(total / 100);
        active.filter(Boolean).forEach(choice => {
          choice.querySelector('[data-choice-price]').textContent = choice.querySelector('select').selectedOptions[0].dataset.money;
        });
        shuffle.disabled = busy || panels.length < 2;
        if (!panels.length) status.textContent = 'These routines are currently unavailable. Explore the shop for more options.';
        if (active.some(choice => !choice)) status.textContent = 'One step is out of stock. Browse the available products above.';
      }
      steps.forEach(step => {
        step.querySelectorAll('select').forEach(select => select.addEventListener('change', update));
      });
      shuffle.addEventListener('click', () => {
        if (busy) return;
        panelIndex = (panelIndex + 1 + Math.floor(Math.random() * (panels.length - 1))) % panels.length;
        panels.forEach((panel, i) => { panel.hidden = i !== panelIndex; });
        update();
        status.textContent = panels[panelIndex].dataset.routineName + ' selected.';
      });
      add.addEventListener('click', async () => {
        if (busy || add.disabled) return;
        const items = activeChoices().map(choice => ({id: Number(choice.querySelector('select').value),quantity:1}));
        const idleLabel = add.textContent;
        const controller = new AbortController();
        let timeoutId;
        let timedOut = false;
        busy = true; update(); add.textContent = 'ADDING TO BAG…'; status.textContent = '';
        section.querySelectorAll('select').forEach(control => {control.disabled = true;});
        try {
          const request = (async () => {
            const response = await fetch(section.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items}),signal:controller.signal});
            return {response, result: await response.json()};
          })();
          const timeout = new Promise((_, reject) => {
            timeoutId = setTimeout(() => {
              timedOut = true;
              reject(new Error('Routine request timed out'));
              controller.abort();
            }, 20000);
          });
          const {response, result} = await Promise.race([request, timeout]);
          if (!response.ok || result.status) throw new Error(result.description || result.message || 'Could not add the routine. Please check your bag before trying again.');
          status.textContent = 'Your routine is in your bag. Opening your bag…';
          window.location.assign(section.dataset.cartUrl);
        } catch (error) {
          status.textContent = timedOut
            ? 'This is taking longer than expected. Your products may already be in your bag. Check your bag before trying again. '
            : (error.message || 'Connection interrupted.') + ' Check your bag before trying again. ';
          const bagLink = document.createElement('a');
          bagLink.href = section.dataset.cartUrl;
          bagLink.textContent = 'Check your bag';
          status.appendChild(bagLink);
        } finally {
          clearTimeout(timeoutId);
          busy = false; add.textContent = idleLabel;
          section.querySelectorAll('select').forEach(control => {control.disabled = false;});
          update();
        }
      });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
